const ITEMS = [
  "HTI Hospitality — Regional Distributor",
  "KRA eTIMS Ready",
  "M-Pesa Integrated",
  "PassportScan Partner",
  "HostPoint POS",
  "HostPoint Retail",
  "nebula CRS · PMS · POS",
  "Nairobi · Kenya",
  "24/7 Support Desk",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-[#263562]/10 bg-[#F5F8FC] py-6 overflow-hidden"
      aria-label="Capabilities ticker"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-lg sm:text-xl tracking-tight text-[#263562] px-8">
              {item}
            </span>
            <span className="text-[#3AB0E1] text-xs">◆</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#F5F8FC] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#F5F8FC] to-transparent" />
    </section>
  );
}
